import { kNameOfSimplePluginService } from 'app-core/src/constants/constants';
import { injectable, inject } from 'tsyringe';
import { OwSimplePluginService } from './simple-plugin-service.ts/simple-plugin.service';

// -----------------------------------------------------------------------------
@injectable()
export class OwRegistryWrapper {
  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kNameOfSimplePluginService)
    private readonly pluginService: OwSimplePluginService,
  ) {}

  // -------------------------------------------------------------------------
  async getLocalMachineKey(keyPath, KeyName) {
    return this.pluginService.getRegistryKey('LocalMachine', keyPath, KeyName);
  }

  // -------------------------------------------------------------------------
  async getCurrentUserKey(keyPath, KeyName) {
    return this.pluginService.getRegistryKey('CurrentUser', keyPath, KeyName);
  }

  // --------------------------------------------------------------------------
  async getClassesRootKey(keyPath, KeyName) {
    return this.pluginService.getRegistryKey('ClassesRoot', keyPath, KeyName);
  }

  // --------------------------------------------------------------------------
  async getUsersKey(keyPath, KeyName) {
    return this.pluginService.getRegistryKey('users', keyPath, KeyName);
  }

  // -------------------------------------------------------------------------
  async getLocalMachineKeyList(keyPath) {
    return this.pluginService.getRegistryKeyList('LocalMachine', keyPath);
  }

  // -------------------------------------------------------------------------
  async getCurrentUserKeyList(keyPath) {
    return this.pluginService.getRegistryKeyList('CurrentUser', keyPath);
  }

  // --------------------------------------------------------------------------
  async getClassesRootKeyList(keyPath) {
    return this.pluginService.getRegistryKeyList('ClassesRoot', keyPath);
  }

  // --------------------------------------------------------------------------
  async getUsersKeyList(keyPath) {
    return this.pluginService.getRegistryKeyList('users', keyPath);
  }
}
